import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApiErrorMessage, portalApi } from '../../api/client';
import { Button } from '../../components/ui/Button';
import { TotpInput } from '../../components/ui/TotpInput';
import { PENDING_2FA_KEY, TOKEN_STORAGE_KEY } from '../../config';
import { useAuth } from '../../context/AuthContext';

export function Verify2faPage() {
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const pending = localStorage.getItem(PENDING_2FA_KEY);
    if (!pending) {
      navigate('/login');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await portalApi.verify2fa(code, pending);
      if (!res.ok || !res.token) throw new Error(res.error ?? 'Verification failed');
      localStorage.setItem(TOKEN_STORAGE_KEY, res.token);
      setToken(res.token);
      navigate('/');
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="glass-panel w-full max-w-md p-8 space-y-6 text-center">
        <h1 className="font-display text-2xl">Two-factor authentication</h1>
        <p className="text-sm text-onyx-muted">Enter the 6-digit code from Google Authenticator</p>
        <TotpInput value={code} onChange={setCode} />
        {error ? <p className="text-sm text-onyx-danger">{error}</p> : null}
        <Button type="submit" className="w-full" disabled={loading || code.length !== 6}>
          Verify
        </Button>
      </form>
    </div>
  );
}
